/** Categories of trackable metric events by web page */
export enum MetricCategory {
  TodayWebPage = 'today_web_page',
  PathsWebPage = 'paths_web_page',
  PreventWebPage = 'prevent_web_page',
}

/** Actions that can be recorded for a metric event */
export enum MetricAction {
  View = 'view',
}

/** Analytics event payload sent to the metrics tracking endpoint */
export interface MetricEventDTO {
  category: MetricCategory;
  action: MetricAction;
  payload?: Record<string, unknown>;
}
